import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Suspense as _Suspense, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "grid mb-4" }
const _hoisted_3 = { class: "col-12 lg:col-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "col-12 lg:col-3" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "col-12 lg:col-3" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "col-12 lg:col-3" }
const _hoisted_21 = { class: "col-12 lg:col-3" }
const _hoisted_22 = { class: "col-12 lg:col-3" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { class: "mr-1" }
const _hoisted_28 = { class: "flex font-semibold" }
const _hoisted_29 = { class: "mr-1" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "mr-1" }
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "mr-1" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "mr-1" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "mr-1" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "mr-1" }
const _hoisted_40 = { class: "flex mb-3 font-semibold" }
const _hoisted_41 = { class: "mr-1" }
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = { class: "mr-1" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { class: "mr-1" }
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = { class: "mr-1" }
const _hoisted_48 = { class: "flex" }
const _hoisted_49 = { class: "mr-1" }
const _hoisted_50 = { class: "flex" }
const _hoisted_51 = { class: "mr-1" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = { class: "mr-1" }
const _hoisted_54 = { class: "flex" }
const _hoisted_55 = { class: "mr-1" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1" }, ":", -1)
const _hoisted_57 = { key: 1 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1" }, ":", -1)
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_61 = {
  key: 1,
  class: "flex align-items-center"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1" }, "CTR:", -1)
const _hoisted_63 = {
  key: 2,
  class: "flex align-items-center"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1" }, "Bot CTR:", -1)
const _hoisted_65 = {
  key: 3,
  class: "flex align-items-center"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "mr-1" }, "Land. CTR:", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_68 = { class: "font-semibold" }
const _hoisted_69 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldDate = _resolveComponent("FieldDate")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueRow = _resolveComponent("PrimeVueRow")!
  const _component_Subid = _resolveComponent("Subid")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_HighlightedNumber = _resolveComponent("HighlightedNumber")!
  const _component_Platform = _resolveComponent("Platform")!
  const _component_Browser = _resolveComponent("Browser")!
  const _component_SubidStatus = _resolveComponent("SubidStatus")!
  const _component_EntriesDataTableNext = _resolveComponent("EntriesDataTableNext")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: `${_ctx.$t('checker')} 🧪`
    }, null, 8, ["title"]),
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('filters')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.user.isSuperAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_FieldDropdown, {
                  key: `statistics_filters_project_id_${_ctx.statisticsFiltersKeyCounter}`,
                  modelValue: _ctx.statisticsFilters.project_id,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statisticsFilters.project_id) = $event)),
                    _ctx.onProjectChange
                  ],
                  label: _ctx.$t('project'),
                  "show-clear": true,
                  loading: _ctx.projectsLoading,
                  options: _ctx.projects.data,
                  "option-value": "id",
                  "option-label": "name",
                  "option-label-translate": false,
                  multiple: true
                }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FieldDate, {
              modelValue: _ctx.statisticsFilters.date_from,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.statisticsFilters.date_from) = $event)),
              label: _ctx.$t('date_from')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FieldDate, {
              modelValue: _ctx.statisticsFilters.date_to,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statisticsFilters.date_to) = $event)),
              label: _ctx.$t('date_to')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_link_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.link_id,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statisticsFilters.link_id) = $event)),
                _ctx.onLinkChange
              ],
              label: _ctx.$t('ref_link'),
              filter: true,
              "show-clear": true,
              loading: _ctx.linksLoading,
              options: _ctx.links.data,
              "option-value": "id",
              "option-label": "compiled_name",
              "option-label-translate": false,
              multiple: true,
              "multiple-sort-by-value": true
            }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_traffic_source_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.traffic_source,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.statisticsFilters.traffic_source) = $event)),
              modelModifiers: { number: true },
              name: "traffic_source",
              label: _ctx.$t('traffic_source'),
              options: _ctx.TRAFFIC_SOURCES
            }, null, 8, ["modelValue", "label", "options"]))
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_publisher_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.publisher_id,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.statisticsFilters.publisher_id) = $event)),
                _ctx.onPublisherChange
              ],
              label: _ctx.$t('publisher'),
              filter: true,
              "show-clear": true,
              loading: _ctx.usersLoading,
              options: _ctx.users.data,
              "option-value": "id",
              "option-label": "compiled_name",
              "option-label-translate": false,
              multiple: true,
              "multiple-sort-by-value": true
            }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_endpoint_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.endpoint_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.statisticsFilters.endpoint_id) = $event)),
              label: _ctx.$t('endpoint'),
              filter: true,
              "show-clear": true,
              loading: _ctx.endpointsLoading,
              options: _ctx.endpoints.data,
              "option-value": "id",
              "option-label": "compiled_name",
              "option-label-translate": false,
              multiple: true,
              "multiple-sort-by-value": true
            }, null, 8, ["modelValue", "label", "loading", "options"]))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_FieldText, {
              modelValue: _ctx.statisticsFilters.subid_uuid,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.statisticsFilters.subid_uuid) = $event)),
              modelModifiers: { trim: true },
              label: _ctx.$t('subid_uuid')
            }, null, 8, ["modelValue", "label"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_country_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.country_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.statisticsFilters.country_id) = $event)),
              label: _ctx.$t('country'),
              filter: true,
              "show-clear": true,
              loading: _ctx.countriesLoading,
              options: _ctx.countries.data,
              "option-value": "id",
              "option-label": "compiled_name",
              "option-label-translate": false,
              multiple: true
            }, null, 8, ["modelValue", "label", "loading", "options"]))
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_platform_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.platform_id,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.statisticsFilters.platform_id) = $event)),
              label: _ctx.$t('platforms'),
              filter: true,
              "show-clear": true,
              loading: _ctx.platformsLoading,
              options: _ctx.platforms.data,
              "option-value": "id",
              "option-label": "name",
              "option-label-translate": false,
              multiple: true
            }, null, 8, ["modelValue", "label", "loading", "options"]))
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(), _createBlock(_component_FieldDropdown, {
              key: `statistics_filters_browser_id_${_ctx.statisticsFiltersKeyCounter}`,
              modelValue: _ctx.statisticsFilters.browser_id,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.statisticsFilters.browser_id) = $event)),
              label: _ctx.$t('browser'),
              filter: true,
              "show-clear": true,
              loading: _ctx.browsersLoading,
              options: _ctx.browsers.data,
              "option-value": "id",
              "option-label": "name",
              "option-label-translate": false,
              multiple: true
            }, null, 8, ["modelValue", "label", "loading", "options"]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_FieldCheckbox, {
          class: "mb-0",
          modelValue: _ctx.statisticsFilters.show_unique_clicks,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.statisticsFilters.show_unique_clicks) = $event)),
          label: _ctx.$t('show_unique_clicks')
        }, null, 8, ["modelValue", "label"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_PrimeVueButton, {
          class: "p-button-primary w-full mb-3",
          label: _ctx.$t('apply'),
          loading: _ctx.statisticsLoading,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.fetchStatisticsWrapper(_ctx.previousStatisticsPaginator)))
        }, null, 8, ["label", "loading"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_PrimeVueButton, {
          class: "p-button-outlined p-button-secondary w-full",
          label: _ctx.$t('reset'),
          onClick: _ctx.resetStatisticsFilters
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createVNode(_component_Header, {
      class: "mb-3",
      "show-refresh-button": _ctx.statisticsFetched,
      "refresh-button-loading": _ctx.statisticsLoading,
      "refresh-button-handler": _ctx.fetchStatisticsWrapper
    }, {
      title: _withCtx(() => [
        _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t('subids')), 1)
      ]),
      _: 1
    }, 8, ["show-refresh-button", "refresh-button-loading", "refresh-button-handler"]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_EntriesDataTableNext, {
        class: "p-datatable-sm statistics-table text-xs",
        entries: _ctx.statistics,
        "entries-loading": _ctx.statisticsLoading,
        "entries-fetched": _ctx.statisticsFetched,
        "entries-handler": _ctx.fetchStatisticsWrapper,
        "default-sort-by": "clicks",
        lazy: "",
        "data-key": "subid_uuid",
        "row-class": _ctx.getStatisticRowClass,
        "show-gridlines": ""
      }, {
        header: _withCtx(() => [
          _createVNode(_component_PrimeVueRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('subid'),
                field: "subid_uuid"
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: "CTR",
                field: "ctr_not_pop"
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('clicks'),
                field: "clicks"
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('filters')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('filters_too')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('connection')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('platforms')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('browsers')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('has_cookies'),
                field: "clicks_has_cookies"
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('has_social_auth'),
                field: "clicks_has_social_auth"
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('activity')
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, { header: "Subid status" }),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('feeds'),
                field: "publishers_payout_by_feeds"
              }, null, 8, ["header"]),
              _createVNode(_component_PrimeVueColumn, {
                header: _ctx.$t('campaigns'),
                field: "publishers_payout_by_campaigns"
              }, null, 8, ["header"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (_openBlock(), _createBlock(_Suspense, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Subid, {
                    "subid-uuid": data.subid_uuid,
                    subid: data.subid,
                    "onUpdate:subid": ($event: any) => ((data.subid) = $event),
                    "quality-presets": _ctx.qualityPresets,
                    "quality-presets-fetched": _ctx.qualityPresetsFetched,
                    "icon-size": _ctx.iconSize
                  }, null, 8, ["subid-uuid", "subid", "onUpdate:subid", "quality-presets", "quality-presets-fetched", "icon-size"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                ]),
                _: 2
              }, 1024))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_HighlightedNumber, {
                number: data.ctr_not_pop,
                "number-format": "percent_with_fraction",
                "threshold-warning": 0.02,
                "threshold-danger": 0.05,
                "negative-context": ""
              }, null, 8, ["number", "threshold-warning", "threshold-danger"])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (data.clicks_unique)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$n(data.clicks)), 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('unique')) + ":", 1),
                      _createVNode(_component_HighlightedNumber, {
                        number: data.clicks_unique_percent,
                        "number-format": "percent",
                        "threshold-warning": 0.7,
                        "threshold-danger": 0.4
                      }, null, 8, ["number", "threshold-warning", "threshold-danger"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$n(data.clicks)), 1)
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('filtered')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('filter_not_checked')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_not_checked_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('filter_has_no_js')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_has_no_js_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('filter_proxy')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_proxy_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.1,
                  "threshold-danger": 0.3,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('filter_iframe')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_iframe_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.1,
                  "threshold-danger": 0.3,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('filter_headless')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_headless_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('proxy_requests')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.requests_proxy_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('filter_ip_mismatch')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_ip_mismatch_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('filter_user_agent_mismatch')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_user_agent_mismatch_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('filter_referrer_mismatch')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_referrer_mismatch_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('filter_double_click')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_double_click_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.35,
                  "threshold-danger": 0.7,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('filter_click_without_impression')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_filtered_by_click_without_impression_percent,
                  "number-format": "percent",
                  "threshold-warning": 0.1,
                  "threshold-danger": 0.2,
                  "negative-context": ""
                }, null, 8, ["number", "threshold-warning", "threshold-danger"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('carrier')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_usage_type_mob_percent,
                  "number-format": "percent",
                  "disable-threshold": ""
                }, null, 8, ["number"])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('wi_fi')) + ":", 1),
                _createVNode(_component_HighlightedNumber, {
                  number: data.clicks_usage_type_not_mob_percent,
                  "number-format": "percent",
                  "disable-threshold": ""
                }, null, 8, ["number"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (data.platforms)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.platforms, (platformData) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex align-items-center",
                      key: `${data.subid_uuid}_${platformData.platform_id}`
                    }, [
                      (_openBlock(), _createBlock(_Suspense, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Platform, {
                            platform: platformData.platform
                          }, null, 8, ["platform"])
                        ]),
                        fallback: _withCtx(() => [
                          _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                        ]),
                        _: 2
                      }, 1024)),
                      _hoisted_56,
                      _createVNode(_component_HighlightedNumber, {
                        number: platformData.clicks_percent,
                        "number-format": "percent",
                        "disable-threshold": ""
                      }, null, 8, ["number"])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, "—"))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (data.browsers)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.browsers, (browserData) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex align-items-center",
                      key: `${data.subid_uuid}_${browserData.browser_id}`
                    }, [
                      (_openBlock(), _createBlock(_Suspense, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Browser, {
                            browser: browserData.browser
                          }, null, 8, ["browser"])
                        ]),
                        fallback: _withCtx(() => [
                          _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                        ]),
                        _: 2
                      }, 1024)),
                      _hoisted_58,
                      _createVNode(_component_HighlightedNumber, {
                        number: browserData.clicks_percent,
                        "number-format": "percent",
                        "disable-threshold": ""
                      }, null, 8, ["number"])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_59, "—"))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_HighlightedNumber, {
                number: data.clicks_has_cookies_percent,
                "number-format": "percent",
                "threshold-warning": 0.75,
                "threshold-danger": 0.5
              }, null, 8, ["number", "threshold-warning", "threshold-danger"])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_HighlightedNumber, {
                number: data.clicks_has_social_auth_percent,
                "number-format": "percent",
                "threshold-warning": 0.2,
                "threshold-danger": 0.1
              }, null, 8, ["number", "threshold-warning", "threshold-danger"])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (data.clicks_check_initialized_via_landing !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.$n(data.clicks_check_initialized_via_landing)), 1))
                : _createCommentVNode("", true),
              (data.clicks_landing_ctr_good)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_HighlightedNumber, {
                      number: data.clicks_landing_ctr_good,
                      "number-format": "percent_with_fraction",
                      "threshold-warning": 0.03,
                      "threshold-danger": 0
                    }, null, 8, ["number", "threshold-warning"])
                  ]))
                : _createCommentVNode("", true),
              (data.clicks_landing_ctr_bad !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_HighlightedNumber, {
                      number: data.clicks_landing_ctr_bad,
                      "number-format": "percent_with_fraction",
                      "threshold-warning": 0.01,
                      "threshold-danger": 0.03,
                      "negative-context": ""
                    }, null, 8, ["number", "threshold-warning", "threshold-danger"])
                  ]))
                : _createCommentVNode("", true),
              (data.external_landing_ctr !== undefined && _ctx.user.isSuperAdmin())
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("div", null, _toDisplayString(_ctx.$n(data.external_landing_ctr, 'percent_with_fraction')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              (data.subid)
                ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SubidStatus, {
                        subid: data.subid,
                        "onUpdate:subid": ($event: any) => ((data.subid) = $event)
                      }, null, 8, ["subid", "onUpdate:subid"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, {
                        class: "my-1",
                        height: "5px"
                      })
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_67
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('publishers_payout')) + ": " + _toDisplayString(_ctx.$n(data.publishers_payout_by_feeds, 'payout')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('publishers_payout')) + ": " + _toDisplayString(_ctx.$n(data.publishers_payout_by_campaigns, 'payout')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('conversions')) + ": " + _toDisplayString(_ctx.$n(data.conversions)) + " (" + _toDisplayString(_ctx.$n(data.conversions_payout, 'payout')) + ")", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["entries", "entries-loading", "entries-fetched", "entries-handler", "row-class"])
    ])
  ], 64))
}